/**
 * Hjelpemetoder for window.timeout
 */
import {DestroyRef} from "@angular/core";
import {erIkkeNil} from "./nilsjekk";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {nil} from "felles-ng2/typer/nullish";

const debug = initDebugger('Skedulering');

/** Pakker inn {@link window.setTimeout} for enklere bruk */
export class Skedulering {

    private aktivSkedulering: number | null = null;
    private skeduleringBlokkert = false;
    private arbeidUtføres = false;
    private arbeid!: Function;

    /** Oppretter ny skedulering
     * @param forsinkelse forsinkelse i millisekunder */
    constructor(private forsinkelse: number, private beskrivelse = '', destroyRef: DestroyRef | null = null) {
        if (erIkkeNil(destroyRef)) destroyRef.onDestroy(() => this.kanseler());
    }

    skeduler(arbeid: Function): Skedulering {
        if (this.skeduleringBlokkert) {
            debug(`${this.beskrivelse}: skedulering blokkert`)
            return this;
        }

        debug(`${this.beskrivelse}: skedulerer arbeid`)
        this.arbeid = arbeid;
        kanselerSkedulering(this.aktivSkedulering);
        this.aktivSkedulering = window.setTimeout(() => this.utførArbeid(), this.forsinkelse);
        return this;
    }

    /** true dersom det er skedulert noe arbeid som venter på å bli utført */
    erArbeidSkedulert() {
        return erIkkeNil(this.aktivSkedulering);
    }

    /** true dersom skedulert arbeid er i ferd med å bli utført */
    erArbeidUtføres() {
        return this.arbeidUtføres;
    }

    /** true dersom kommende skeduleringer vil bli blokkert */
    erSkeduleringBlokkeres() {
        return this.skeduleringBlokkert;
    }

    /** Sørger for at kall til {@link #skeduler} ikke vil ha noen effekt de neste 'periode' millisekundene,
     * eventuell aktiv skedulering vil bli avbrutt. */
    blokkerSkeduleringer(periode: number): Skedulering {
        debug(`${this.beskrivelse}: skedulering blokkeres de neste ${periode}ms`)
        this.kanseler();
        this.skeduleringBlokkert = true;
        window.setTimeout(() => this.skeduleringBlokkert = false, periode);
        return this;
    }

    kanseler(): Skedulering {
        if (!this.erArbeidSkedulert()) return this;

        debug(`${this.beskrivelse}: kansellerer arbeid`)
        kanselerSkedulering(this.aktivSkedulering);
        this.aktivSkedulering = null;
        return this;
    }

     toString(){
        return `erArbeidSkedulert: ${this.erArbeidSkedulert()}, erArbeidUtføres: ${this.erArbeidUtføres()}, erSkeduleringBlokkeres: ${this.erSkeduleringBlokkeres()}`
     }

    // hjelpemetoder

    private utførArbeid() {
        debug(`${this.beskrivelse}: utfører arbeid`)
        this.aktivSkedulering = null;
        this.arbeidUtføres = true;
        try {
            this.arbeid();
        } finally {
            this.arbeidUtføres = false;
        }
    }
}

export function kanselerSkedulering(aktivSkedulering: number | nil) {
    window.clearTimeout(aktivSkedulering ?? undefined);
}
